export const colors = {
  brandGradientDefault: "linear-gradient(125deg, #61019B 0%, #005FC8 100%)",
  brandGradientColorStopsStart: "#61019B",
  brandGradientColorStopsEnd: "#005FC8",
};

export const text = {
  themeName: "Casino Dark",
};